import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withFirebase, withFirestore } from 'react-redux-firebase';

const styles = theme => ({
  root: {
    width: '100%',
    minHeight: '500px'
  },
  uploadButton: {
    width: '30px',
    border: '1px solid',
    marginRight: '5px',
    backgroundColor: '#0070FF',
    color: 'white',
    height: '100%'
  },
  spinnerContainer: {
    marginRight: '5px',
    width: '73px'
  },
  downArrow: {
    display: 'block',
    margin: '0 auto'
  }
});

const mapStateToProps = state => {
  return {
    profile: state.firebase.profile
  };
};

export default compose(
  withFirebase,
  withFirestore,
  connect(
    mapStateToProps,
    null
  ),
  withProps(({ profile }) => ({
    profile
  })),
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/messaging/conversation/message-form/MessageForm.enhancer.js